import i18n from '../../i18n';
import type { SharePointLocation } from '../../data/types';
import { showContentModal } from '../ui/Modal';
import { ChooseLocationDialog } from './ChooseLocationDialog';

/** Lets a template author pick a destination without saving anything. */
export function showChooseLocationModal(
  initialLocation: SharePointLocation | null,
  onChoose: (location: SharePointLocation) => void
): void {
  showContentModal({
    title: i18n.t('sharePoint.choose.title'),
    body: (close) => <ChooseLocationDialog initialLocation={initialLocation} onChoose={onChoose} close={close} />,
    size: 'wide'
  });
}
